// Define enums for user PermissionType
export enum PermissionType {
  ALL = 'all',
  APPLICATIONS = 'Applications',
  MANUAL_APPLICATIONS = 'Manual Applications',
  ACCOUNTS = 'Accounts',
  FILES = 'Files', //  TODO: remove?
  IPPFILES = 'IPPFiles',
  CUSTOMER = 'Customers',
  CARDS = 'Cards',
  MESSAGES = 'Messages',
  PRODUCTS = 'Products',
  TRANSACTIONS = 'Transactions',
  CREDITLIMIT = 'CreditLimit',
  CREDIT_LIMIT_REQUESTS = 'CreditLimitRequests',
  SALES_DOCUMENTS = 'SalesDocuments',
  GENERAL = 'General',
}
